import { GetOrganizacaoService } from "../../Services/Organizacao/Organizacao";
import { Controller } from "../Controller";

export async function GetOrganizacaoController() {
    return Controller(GetOrganizacaoService());
}
